<div class="row">
  <!-- *ngIf="showBookingAndCancelButton !==1 && (!patientRservedByDoctorInCallCenter)" -->
  <div class="col-sm-2">
    <div class="form-group">
      <sanabel-selectize appcode="1016" [(ngModel)]="speciality" #specialitySearch
        (clicked)="specialitySearchClicked($event)"></sanabel-selectize>
    </div>
  </div>
  <div class="col-sm-2">
    <label>{{ "DOCTOR" | translate }}</label>
    <!-- 1430 -->
    <sanabel-selectize appcode="1014" [simpleView]="true" [(ngModel)]="docId" name="doctor"
      (clicked)="docIdSearchClicked($event)" #doctorSearch>
    </sanabel-selectize>
  </div>

  <div class="col-2" *ngIf="showPatient">
    <div class="row mx-0 align-items-center">
      <label for="birthDate">{{'SHIFTSS' | translate}}</label>
      <div class="input-group input-group-sm">
        <select class="form-control" (change)="ShiftSelect($event)" style="border-color: #afafaf;">
          <option disabled selected>{{'CHOOSESHIFT' | translate}} </option>
          <option value="1">{{'SHIFT1' | translate}}</option>
          <option value="2">{{'SHIFT2' | translate}}</option>
          <option value="3">{{'SHIFT3' | translate}}</option>
        </select>
      </div>
    </div>
  </div>
  <div class="col-2">
    <label>{{ 'APPOINTMENTS' | translate }}</label>
    <sanabel-selectize appcode="65" [(ngModel)]="monthlyOrDaily" (itemSelected)="dailyOrMonthClick($event)"
      [simpleView]="true">
    </sanabel-selectize>
  </div>
  <div class="col-sm-2" *ngIf="periodType==1">
    <label>{{ 'DATE' | translate }}</label>
    <div class="form-group">
      <div class="input-group input-group-sm">
        <input class="form-control" placeholder="{{'DATEFORMAT' | translate}}" [(ngModel)]="date" ngbDatepicker
          (ngModelChange)="monthlyDoctoroutPatient($event)" #datee="ngbDatepicker">
        <div class="input-group-addon" (click)="datee.toggle()">
          <i class="fa fa-calendar"></i>
        </div>
      </div>
    </div>
  </div>
  <div class="col-2" *ngIf="monthlyOrDaily==3|| monthlyOrDaily==2">
    <label>{{'MONTH' | translate}}</label>
    <sanabel-selectize appcode="57" [simpleView]="true" [(ngModel)]="monthNo" (clicked)="monthNoClick($event)"
      [required]="true" name="month">
    </sanabel-selectize>
  </div>
  <div class="col-2" *ngIf="showPatient">
    <label>{{ 'PATIENT' | translate }}</label>
    <sanabel-selectize appcode="1023" [(ngModel)]="patCode" name="patient" (clicked)="patientClicked($event,1)"
      [simpleView]="true">
    </sanabel-selectize>
  </div>
</div>
<div class="row" style="margin-bottom: 25px;">
  <div class="col-2" *ngIf="showPatient">
    <label>{{ 'CLIENT' | translate }}</label>
    <sanabel-selectize appcode="1162" name="patient" (clicked)="patientClicked($event,2)" [simpleView]="true">
    </sanabel-selectize>
  </div>
  <div class="col-2" *ngIf="showPatient">
    <label>{{ 'MOBILE' | translate }}</label>
    <!-- <sanabel-selectize appcode="14369" [(ngModel)]="phoneNumber" (clicked)="patientClicked($event,3)" [simpleView]="true">
    </sanabel-selectize> -->
    <input type="text" class="form-control" [(ngModel)]="phoneNumber" (keyup.enter)="patientClicked(phoneNumber,3)">
  </div>
  <div class="col-1" *ngIf="monthlyOrDaily">
    <i class="fa fa-refresh" aria-hidden="true" (click)="refreshData(monthlyOrDaily)"
      style="font-size: 35px;color: #45a4f9;padding-top: 28px;cursor: pointer;"></i>
  </div>
</div>
<!-- book area  from doctor-->
<div>
  <div class="row"
    *ngIf="(patientRservedByDoctorInCallCenter==2 || patientRservedByDoctorInCallCenter==3) && patCode>0">
    <!-- <div class="col-2">
      <button class="btn btn-primary p-2 m-3" (click)="patientBookedByCall()">{{'Appointment Booking ' |
        translate}}</button>
    </div>
    <div class="col-2">
      <button *ngIf="showPatBookArea==1" class="btn btn-primary p-2 m-3" (click)="cancelPatientBookedByCall()">{{'Cancel
        Booking' |translate}}</button>
    </div> -->

    <div class="col-2 m-2">
      <button type="button" class="btn btn-success fa-pull-right fs-it-btn" *ngIf="showPatBookArea ==0"
        (click)="patientBookedByCall()">
        <i class="fa fa-plus fa-custom" aria-hidden="true"></i>
        <span class="fs-it-btn-vertical-line"></span>
        {{'Appointment Booking ' |
        translate}}
      </button>
      <button type="button" class="btn btn-danger fa-pull-right fs-it-btn" *ngIf="showPatBookArea==1"
        (click)="cancelPatientBookedByCall()">
        <i class="fa fa-times fa-custom" aria-hidden="true"></i>
        <span class="fs-it-btn-vertical-line"></span>
        {{'CancelBooking' |translate}}
      </button>
    </div>

  </div>
  <div *ngIf="showPatBookArea==1" class="row">
    <div class="col-sm-2">
      <div class="form-group">
        <sanabel-selectize appcode="1016 " [SearchKeys]="{EmpId :docId}"
          [(ngModel)]="callData.specialization"></sanabel-selectize>
      </div>
    </div>
    <div class="col-sm-2">
      <div class="form-group">
        <div>
          <sanabel-selectize appcode="1466" [SearchKeys]="{ResourceId :docId, ResourceType:100}"
            [(ngModel)]="callData.clinicCode"></sanabel-selectize>
        </div>
      </div>
    </div>
    <!-- <div class="col-sm-2">
      <div class="form-group">
        <div>
          <sanabel-selectize appcode="1065" [(ngModel)]="callData.branchAddress"></sanabel-selectize>
        </div>
      </div>
    </div> -->
    <div class="col-sm-2" style="margin-top: 33px;">
      <input type="checkbox" name="sendMessageFlag" [(ngModel)]="sendMessageFlag">Send sms Message
    </div>



    <div class="col-sm-1" style="margin-top: 33px;">
      <button class="btn btn-primary px-5 " (click)="savePatientBookedByCall()">{{'Save' |
        translate}}</button>
    </div>
  </div>
</div>

<!-- monthly -->
<div *ngIf="showMonthlyMatirx==1">
  <app-monthly-resources-slot-view [showPatCode]="1" [periodType]="periodType" [isSlotDaraggable]="true"
    [scheduleType]="2" (currentSlot)="selectedCurrentSlot($event)"
    (onSlotRightActionClick)="emitOnSlotRightActionClick($event)" [listeningGuid]="6"
    (unCurrentSlot)="unSelectedCurrentSlot($event)" (ReservedCurrentSlot)="selectedReservedCurrentSlot($event)"
    (dbC_CurrentSlot)="selectedDBC_CurrentSlot($event)">
  </app-monthly-resources-slot-view>
</div>
<!-- daily -->
<!-- <div *ngIf="showMonthlyMatirx==0">
  <doctor-time-inquery [activePage]="'clinic'">
  </doctor-time-inquery>
</div> -->
<div class="modal " id="rightClickedSlot" style="display:none;">
  <div class="modal-content shadow p-3 mb-5 bg-white rounded">
    <span (click)="closeRightClickedSlot()" class="close">&times;
    </span>
    <div class="text-center">
      <div class="row">
        <div class="col-6">
          <sanabel-selectize appcode="1016" [(ngModel)]="specialityFromMatrix" #specialitySearchFromMatrix
            (clicked)="specialitySearchFromMatrixClicked($event)"></sanabel-selectize>
        </div>

        <div class="col-sm-6 ">
          <sanabel-selectize appcode="1052" [(ngModel)]="docIdFromMatrix" #doctorSearchFromMatrix
            (clicked)="docIdSearchFromMatrixClicked($event)"></sanabel-selectize>
        </div>
      </div>
      <div class="p-2">
        <button type="button" class="btn btn-success fs-it-btn "
          (click)="updatePatientReservationDoctorFromMonthlyMatrix()">
          <i class="fa fa-floppy-o fa-custom" aria-hidden="true"></i>
          <span class="fs-it-btn-vertical-line"></span>
          {{translate.currentLang=='ar'?'تحديث الطبيب':'Update Doctor'}}
        </button>

      </div>

    </div>
  </div>
</div>
<div>
  <block-modal-container #popup (close)="onpopupClose($event)">
    <ng-container class="modal-body" [ngComponentOutlet]="dynamicComponent"></ng-container>
  </block-modal-container>
</div>